var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamCheckAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.5,7c1.93,0,3.5-1.57,3.5-3.5S7.43,0,5.5,0s-3.5,1.57-3.5,3.5,1.57,3.5,3.5,3.5Zm0-5c.827,0,1.5.673,1.5,1.5s-.673,1.5-1.5,1.5-1.5-.673-1.5-1.5.673-1.5,1.5-1.5Zm9,5c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5-3.5,1.57-3.5,3.5,1.57,3.5,3.5,3.5Zm0-5c.827,0,1.5.673,1.5,1.5s-.673,1.5-1.5,1.5-1.5-.673-1.5-1.5.673-1.5,1.5-1.5Zm-5.402,10.691c-.32.586-.57,1.215-.755,1.871-1.094-.588-1.843-1.733-1.843-3.062,0-1.93,1.57-3.5,3.5-3.5,1.028,0,1.948.452,2.587,1.161-.591.334-1.138.735-1.636,1.189-.26-.215-.588-.35-.951-.35-.827,0-1.5.673-1.5,1.5,0,.487.237.917.598,1.191Zm-4.385-2.691h-1.713c-.552,0-1,.448-1,1v3H0v-3c0-1.654,1.346-3,3-3h2.761c-.479.579-.837,1.259-1.047,2Zm12.287,0c-3.86,0-7,3.141-7,7s3.14,7,7,7,7-3.141,7-7-3.14-7-7-7Zm0,12c-2.757,0-5-2.243-5-5s2.243-5,5-5,5,2.243,5,5-2.243,5-5,5Zm3.992-5.882l-3.457,3.399c-.308.309-.727.482-1.172.482s-.864-.173-1.179-.488l-1.846-1.789,1.393-1.436,1.63,1.58,3.229-3.175,1.402,1.426Zm-12.933-.118c-.036.329-.059.662-.059,1s.022.671.059,1h-1.059c-.551,0-1,.449-1,1v3h-2v-3c0-1.654,1.346-3,3-3h1.059Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamCheckAlt);
export default __webpack_public_path__ + "static/media/team-check-alt.2804cf7374253277d2db61fff72a9f27.svg";
export { ForwardRef as ReactComponent };